import {Box} from 'platform/foundation';

import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {Nullish} from 'shared/web';

export const TableCell = (props: {value: string | Nullish}) => (
  <Box padding={2}>{props.value || EMPTY_PLACEHOLDER}</Box>
);
